import { MedicationHours } from 'src/app/models/fhir-models';

const ALLOWED_MEDICATION_HOURS: ReadonlySet<string> = new Set<string>(Object.values(MedicationHours));

/**
 * Normalizes the `hours` field of a Medication document to a stable string[].
 * Tolerates legacy single-string values ("AM") written before the multi-select migration.
 * Drops any value that is not part of the {@link MedicationHours} enum so corrupted /
 * unexpected Firestore writes (e.g. arbitrary strings) cannot leak into UI or PDF/email
 * exports downstream.
 *
 * Lives in a standalone util (no Angular/DI imports) so both fhir-medications.service and
 * patient-detail.service can consume it without creating a circular dependency.
 */
export const normalizeMedicationHours = (raw: unknown): string[] => {
  if (Array.isArray(raw)) {
    return raw.filter((v): v is string => typeof v === 'string' && ALLOWED_MEDICATION_HOURS.has(v));
  }
  if (typeof raw === 'string' && ALLOWED_MEDICATION_HOURS.has(raw)) {
    return [raw];
  }
  return [];
};
